import { DIRECTIONS, timing, variantForLevel, } from './params';
const FEEDBACK_MS = 600;
export function makeStimulus(trialIdx, durationMs, level) {
    const variant = variantForLevel(level);
    const direction = DIRECTIONS[Math.floor(Math.random() * DIRECTIONS.length)];
    return {
        trialIdx,
        durationMs: Math.max(timing.minRenderMs, durationMs),
        direction,
        coherence: variant.coherence,
        nDots: variant.nDots,
    };
}
export function createVisualSweepsAdapter(level = 1) {
    let state = {
        subPhase: 'idle',
        stim: null,
        feedback: null,
        level,
        variant: variantForLevel(level),
    };
    const listeners = new Set();
    let resolver = null;
    let rejecter = null;
    let trialStart = 0;
    const timers = [];
    function clearTimers() {
        while (timers.length > 0) {
            const t = timers.pop();
            if (t !== undefined)
                clearTimeout(t);
        }
    }
    function update(patch) {
        state = { ...state, ...patch };
        for (const l of listeners) {
            try {
                l(state);
            }
            catch {
                /* ignored */
            }
        }
    }
    return {
        mount() {
            // Idempotent — rendu déclaratif côté React.
        },
        unmount() {
            clearTimers();
            listeners.clear();
            if (rejecter) {
                rejecter(new Error('unmount'));
                rejecter = null;
                resolver = null;
            }
        },
        presentStimulus(stim) {
            clearTimers();
            return new Promise((resolve, reject) => {
                resolver = resolve;
                rejecter = reject;
                update({ subPhase: 'fixation', stim, feedback: null });
                timers.push(setTimeout(() => {
                    update({ subPhase: 'stimulus' });
                    trialStart = Date.now();
                    timers.push(setTimeout(() => {
                        update({ subPhase: 'mask' });
                        timers.push(setTimeout(() => {
                            update({ subPhase: 'awaiting_response' });
                        }, timing.maskMs));
                    }, stim.durationMs));
                }, timing.fixationMs));
            });
        },
        async showFeedback(correct) {
            update({
                subPhase: 'feedback',
                feedback: correct ? 'correct' : 'incorrect',
            });
            await new Promise((resolve) => {
                timers.push(setTimeout(() => {
                    update({ subPhase: 'iti' });
                    resolve();
                }, FEEDBACK_MS));
            });
        },
        pause() {
            // Sprint 0.5 : no-op.
        },
        resume() {
            // Sprint 0.5 : no-op.
        },
        abort() {
            clearTimers();
            if (rejecter) {
                rejecter(new Error('aborted'));
                rejecter = null;
                resolver = null;
            }
        },
        getState() {
            return state;
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(state);
            return () => {
                listeners.delete(listener);
            };
        },
        handleDirectionPick(direction) {
            if (state.subPhase !== 'awaiting_response')
                return;
            const stim = state.stim;
            if (!stim)
                return;
            const correct = direction === stim.direction;
            const rt = Date.now() - trialStart;
            const resp = { pick: direction, correct, reactionTimeMs: rt };
            if (resolver) {
                const r = resolver;
                resolver = null;
                rejecter = null;
                r(resp);
            }
        },
        setLevel(newLevel) {
            const v = variantForLevel(newLevel);
            update({ level: newLevel, variant: v });
        },
    };
}
//# sourceMappingURL=adapter.js.map